// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__lg5Pb","question":"Question_question__3j3mH","description":"Question_description__r-SF2"};